import assert from 'assert';

export const SuccessCode = 200;

export const ErrorCode = {
    NoPermission: 403,
    UrlError: 302,
    NotFound: 404,
    Duplicate: 600,
    uuapExpired: 401,
    serverError: 500,
    NoRepository: 10305,
    AdministratorLimit: 10001,
    userForbidden: 12002,
    // 申请权限审批人权限变更了
    applyMemberError: 403,
    // toc账号未授权
    tocUserUnauthorized: 80004,
    // toc无库权限(目录无数据)
    tocNoRepoError: 10400,
};

export class WizKnownError extends Error {
  code: string | number;

  externCode?: string;

  origin?: any;

  result?: any;

  options?: any;

  constructor(message: string, code: string | number, options: any, externCode?: string, result?: any) {
      super(message);
      assert(message);
      assert(code);
      this.message = message;
      this.code = code;
      if (externCode) {
          this.externCode = externCode;
      }
      if (result) {
          this.result = result;
      }
      if (options) {
          this.options = options;
      }
  }

  static noErrorResult(result = {}) {
      return {
          returnCode: 200,
          returnMessage: 'OK',
          result,
      };
  }

  toResult() {
      return {
          returnCode: this.code,
          returnMessage: this.message,
          externCode: this.externCode,
          code: this.code,
          result: this.result,
      };
  }

  toJSON() {
      return this.toResult();
  }

  log() {
      console.error(this);
  }
}

export class WizInvalidTokenError extends WizKnownError {
    constructor(message: string = 'Invalid token', options: any) {
        super(message, 'WizErrorInvalidToken', options);
    }
}


export class WizInvalidUserError extends WizKnownError {
    constructor(message: string = 'Invalid user', options: any) {
        super(message, 'WizErrorInvalidUser', options);
    }
}


export class WizInvalidPasswordError extends WizKnownError {
    constructor(message: string = 'invalid password', options: any) {
        super(message, 'WizErrorInvalidPassword', options);
    }
}

export class WizInvalidParamError extends WizKnownError {
    constructor(message: string, options: any) {
        super(message, 'WizErrorInvalidParam', options);
    }
}


export class WizNetworkError extends WizKnownError {
    constructor(message: string, options: any) {
        super(message, 'WizErrorNetwork', options);
    }
}

export class WizInternalError extends WizKnownError {
    constructor(message: string, options: any, externCode?: string) {
        super(message, 'WizErrorInternal', options, externCode);
    }
}

export class WizTimeoutError extends WizKnownError {
    //
    constructor(message: string, options: any) {
        super(message, 'WizErrorTimeout', options);
    }

    //
    log() {
        console.error(`${this.code} ${this.message}`);
    }
}

export class WizNotExistsError extends WizKnownError {
    constructor(message: string, options: any) {
        super(message, 'WizNotExistsError', options);
    }
}

export class WizServerError extends WizKnownError {
    constructor(message: string, options: any, externCode?: string) {
        super(message, 'WizErrorServer', options, externCode);
    }
}

export class WizNoPermissionError extends WizKnownError {
    constructor(message: string, options: any, origin?: any) {
        super(message, ErrorCode.NoPermission, options);
        this.origin = origin;
    }
}
